import React from "react";
import Navbar from "../Components/Navbar";
import { Link } from "react-router-dom";
import Footer from "../Components/Footer";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import Background from "../Components/Background";
import hiveMindLight from "../Assets/HiveMindPreview.png"
import hiveMindDark from "../Assets/HiveMindPreviewDark.png"
import HWNID from "../Assets/HWNID.png"
import Project from "../Components/Project";
import gamedev from "../Assets/SinnerONight.png"
import lake from "../Assets/lake.png"
const Projects = () => {
  return (  
    <div className="min-h-screen overflow-y-auto scrollbar-thin">
      <Background />
      <Navbar className="mb-30" />
      <div className="w-full flex flex-col items-center justify-start pt-10 px-4">
        <div className="w-full max-w-6xl flex flex-col items-center justify-start mt-20 space-y-20">
          <h1 className="text-3xl sm:text-6xl xl:text-7xl font-extrabold mx-auto text-center gradient-text dark:gradient-text-dark select-none text-nowrap ">
            Coding Projects:
          </h1>

          {Project("Hive Mind - BEE-Commerce", hiveMindLight, "https://cs2team29.cs2410-web01pvm.aston.ac.uk/public/")}
          {Project("HWNID - Co-operative Task Tracker", HWNID, "https://hwnid.vercel.app")}
          {Project("Souls-Like Game (Unity)", gamedev, "https://samuskii.itch.io/anathena-sinner-o-night")}
          

        </div>

        <div className="w-full max-w-6xl flex flex-col items-center justify-start mt-20 space-y-20">
            <h1 className="text-4xl md:text-7xl font-extrabold max-w-[800px] mx-auto text-center gradient-text dark:gradient-text-dark select-none">
                Photoshop Projects:
            </h1>
            <div id='PHOTOSHOPPROJECTCONTAINER'>
          {Project("Lake", lake)}
          {Project("Another Project", lake)}
            </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default Projects;
